import React, { useEffect, useMemo } from 'react';
import { List, Popover, Modal, notification } from "tea-component";
import { delMenu, moveMenu, addToFavorite, deleteFromFavorite, updateMenuSort } from '@/pages/dashboard/services/leftMenu';
import { history, useIntl, useDispatch, getLocale, useSelector, shallowEqual, useLocation } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { BUSINESS_TYPE_MYDASHBOARD, FOLDER_NAME_FAVORITES, FOLDER_NAME_MYDASHBOARD } from '@/pages/dashboard/_config/constant';
import { useMapData } from '@/pages/dashboard/utils/customHook';
import { getPathFromDashboard } from '@/pages/dashboard/utils/utils';

export default (props: any) => {
  const { item, item: { onclick = '' }, visible, setVisible, referenceElement, folder, setModalInfoState, favoritesDashboardList, moveToMenu } = props;
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const location = useLocation();
  const locale = getLocale();

  const dashboardList = useSelector((state: any) => state?.dashboard?.dashboardList, shallowEqual);
  const isZh = locale === 'zh-CN';
  // 上下移动菜单（报表级别间移动）
  // const orderToMenu = { ...folder, dashoboard_list: folder?.dashoboard_list?.filter((dash: any) => dash?.menu_type === '2') }

  const orderToMenu = useMemo(() => {
    return { ...folder, dashoboard_list: folder?.dashoboard_list?.filter((dash: any) => dash?.menu_type === '2') };
  }, [folder]);

  // 已经被收藏的报表id
  const favDashboardListId = useMapData(favoritesDashboardList, 'id', favoritesDashboardList);
  // 当前报表是否被收藏
  const isFavoriteDashboard = favDashboardListId?.includes(item?.id);

  const { currentGame, userInfo, subscribleEnable } = useSelector(state => {
    // @ts-ignore
    const { currentGame, userInfo } = state?.dashboard || {};
    // @ts-ignore
    const { gameConfig } = state?.dashboardSetting || {};
    const { subscrible_enable } = gameConfig || {};
    return {
      userInfo,
      currentGame,
      subscribleEnable: subscrible_enable
    };
  });

  const menuInfo = useMemo(() => {
    const isFavorite = orderToMenu?.business_type === BUSINESS_TYPE_MYDASHBOARD && orderToMenu?.name_en === FOLDER_NAME_FAVORITES;
    const index = (orderToMenu?.dashoboard_list || []).findIndex((dashboard: any) => {
      return dashboard && dashboard?.id === item?.id;
    });
    const isFirst = index === 0;
    const isLast = index === (orderToMenu?.dashoboard_list.length - 1);
    return {
      isFavorite,
      isFirst,
      isLast,
      index: index
    };
  }, [orderToMenu, item]);

  const { isFavorite, isFirst, isLast } = menuInfo;

  const hancleClickEdit = () => {
    setModalInfoState({
      show: true,
      type: 'edit',
      editType: 'dashboard',
      item: { ...item }
    });
    setVisible(false);
  };

  const openMode = (message: any, callback: () => void) => {
    Modal.confirm({
      message,
      okText: formatMessage({ id: 'menu_confirm' }),
      cancelText: formatMessage({ id: 'menu_cancel' }),
      onOk: callback
    });
  };

  const hancleClickDel = () => {
    const name = (isZh && item?.name_cn) || item?.name_en;
    setVisible(false);
    const message = <div style={{ fontSize: '16px', fontWeight: '400' }}>
      <div style={{ fontWeight: 'bold' }}>
        {formatMessage({ id: 'menu_info_del_1' }) + formatMessage({ id: 'dashboard_title' })}?
      </div>
      <div style={{ marginTop: '5px' }}>
        {formatMessage({ id: 'menu_info_del_2' })}
        <span style={{ fontWeight: 'bold' }}>{name}</span> ?
        <span> {formatMessage({ id: 'menu_info_del_3' })}</span>
      </div>
    </div>;
    openMode(message, doDelMenu);
  };

  const handleMoveToMenu = (folderId: string, targetId: string) => {
    setVisible(false);
    const message = <div style={{ fontSize: '16px', fontWeight: '400' }}><span>{formatMessage({ id: 'menu_info_move' })}</span></div>;
    openMode(message, () => {
      doMoveMenu(folderId, targetId);
    });
  };

  const handleAddToFavorite = () => {
    setVisible(false);
    doAddToFavorite();
  };

  const handleAddToSubsribe = () => {
    const gameCode = currentGame?.game_code;
    const backUrl = history?.location?.pathname;
    const pageNameEn = `${item?.parent_name_en}-${item?.name_en}`;
    const pageNameCn = `${item?.parent_name_cn || item?.parent_name_en}-${item?.name_cn || item?.name_en}`;
    const pagePath = `/${getPathFromDashboard(item)}`;
    const queryStr = `gameCode=${gameCode}&backUrl=${backUrl}&pageNameEn=${pageNameEn}&pageNameCn=${pageNameCn}&path=${pagePath}&pageType=${item?.page_type}&menuId=${item?.id}`;
    setVisible(false);
    history.push(`/dashboard/game/${gameCode}/subscribe/subscribeSetting?queryStr=${queryStr}`);
  };

  const handleDeleteFromFavorite = () => {
    setVisible(false);
    const message = <div style={{ fontSize: '16px', fontWeight: '400' }}><span>{formatMessage({ id: 'menu_info_fav_del' })}</span></div>;
    openMode(message, doDeleteFromFavorite);
  };

  const handleClickShiiftUP = () => {
    setVisible(false);
    const preDashboard = orderToMenu?.dashoboard_list?.[menuInfo.index - 1];
    if (!preDashboard) {
      return;
    }
    doUpdateMenuSort(preDashboard.id);
  };

  const handleClickShiiftDown = () => {
    setVisible(false);
    const nextDashboard = orderToMenu?.dashoboard_list?.[menuInfo.index + 1];
    if (!nextDashboard) {
      return;
    }
    doUpdateMenuSort(nextDashboard.id);
  };

  // 移动folder
  const doMoveMenu = (folderId: string, targetId: string) => {
    moveMenu({
      id: item?.id,
      game_code: currentGame?.game_code,
      target_menu_id: targetId
    }).then(() => {
      dispatch({
        type: 'dashboard/getLeftMenuList',
      });
    }, () => {
    }).catch((err) => {
      console.log(err);
    }).finally(() => {
    });
  };

  // 删除folder
  const doDelMenu = () => {
    delMenu({
      id: item.id,
      game_code: currentGame?.game_code,
    }).then(() => {
      dispatch({
        type: 'dashboard/getLeftMenuList',
      });
      if (location.href?.includes(item.path)) {
        const pathUrl = dashboardList?.[0] ? `/dashboard/game/${currentGame.game_code}/${getPathFromDashboard(
          dashboardList[0],
        )}` : '/home';
        history.push(pathUrl);
      }
    }, () => {
    }).finally(() => {
    });
  };

  const doAddToFavorite = () => {
    addToFavorite({
      user_id: userInfo?.userid,
      metric_code: currentGame.game_code,
      // id 其实就是u_id,在获取接口数据的时候为了兼容老代码做了处理
      u_id: item?.id
    }).then(() => {
      notification.success({
        description: formatMessage({ id: 'menu_add_to_favorites_successfully' }),
        // unique:true
      });
      dispatch({
        type: 'dashboard/getLeftMenuList',
      });
    }).catch((err) => {
      console.log(err);
    });
  };
  // 删除收藏
  const doDeleteFromFavorite = () => {
    deleteFromFavorite({
      user_id: userInfo?.userid,
      metric_code: currentGame.game_code,
      // id 其实就是u_id,在获取接口数据的时候为了兼容老代码做了处理
      u_id: item?.id
    }).then(() => {
      const name = (isZh && item?.name_cn) || item?.name_en;
      notification.success({
        description: <span><strong>{name}</strong>&nbsp;{formatMessage({ id: 'menu_remove_from_favorites_successfully' })}</span>,
        // unique:true
      });

      dispatch({
        type: 'dashboard/getLeftMenuList',
      });
    }).catch((err) => {
      console.log(err);
    });
  };

  // shift up, shift down
  const doUpdateMenuSort = (targetId: string) => {
    updateMenuSort({
      id: item.id,
      target_menu_id: targetId,
      game_code: currentGame?.game_code
    }).then(() => {
      dispatch({
        type: 'dashboard/getLeftMenuList',
      });
    }).catch((err) => {
      console.log(err);
    });
  };

  useEffect(() => {
    if (visible) {
      dispatch({
        type: "dashboard/save",
        payload: {
          showContentMask: true
        }
      });

      dispatch({
        type: 'home/save',
        payload: {
          showGlobalMask: 'transparent',
        },
      });
    } else {
      dispatch({
        type: "dashboard/save",
        payload: {
          showContentMask: false
        }
      });

      dispatch({
        type: 'home/save',
        payload: {
          showGlobalMask: false,
        },
      });
    }
    // setActiveInfo && setActiveInfo({
    //   id: menu?.id,
    //   show: visible,
    // })

    return () => {
      dispatch({
        type: "dashboard/save",
        payload: {
          showContentMask: false
        }
      });

      dispatch({
        type: 'home/save',
        payload: {
          showGlobalMask: false,
        },
      });
    };
  }, [visible]);

  const isShowSplitLine = (subscribleEnable || (folder?.business_type !== BUSINESS_TYPE_MYDASHBOARD && !isFavoriteDashboard) ||
    (folder?.business_type !== BUSINESS_TYPE_MYDASHBOARD && isFavoriteDashboard) || isFavorite);

  return (
    <>
      <Popover
        referenceElement={referenceElement}
        visible={visible}
        onVisibleChange={(val) => { setVisible(val) }}
        placement="right-start"
        placementOffset={[-10, 26]}
        trigger="click"
        overlay={
          <div className='left-nav-exit'>
            <List type="option">
              {subscribleEnable && <List.Item onClick={handleAddToSubsribe}><div className='dbd-sub-nav'><SvgIcon type='flag-plus' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text" >{formatMessage({ id: 'menu_subscribe' })}</div></div></List.Item>}
              {(folder?.business_type !== BUSINESS_TYPE_MYDASHBOARD && !isFavoriteDashboard) && <List.Item onClick={handleAddToFavorite}><div className='dbd-sub-nav'><SvgIcon type='star-add-icon' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text">{formatMessage({ id: 'menu_add_to_favorites' })}</div></div></List.Item>}
              {(folder?.business_type !== BUSINESS_TYPE_MYDASHBOARD && isFavoriteDashboard) && <List.Item onClick={handleDeleteFromFavorite}><div className='dbd-sub-nav'><SvgIcon type='star-delete' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text">{formatMessage({ id: 'menu_remove_to_favorites' })}</div></div></List.Item>}
              {isFavorite && <List.Item onClick={handleDeleteFromFavorite}><div className='dbd-sub-nav'><SvgIcon type='star-delete' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text">{formatMessage({ id: 'menu_remove_to_favorites' })}</div></div></List.Item>}

              {
                onclick === 'true' && !isFavorite && <>
                  {/* 分割线 */}
                  {
                    isShowSplitLine && <List.Item className='tea-list__separate dbd-sub-line' />
                  }

                  <List.Item onClick={hancleClickEdit}><div className='dbd-sub-nav'><SvgIcon type='pencil-m' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text">{formatMessage({ id: 'menu_edit' })}</div></div></List.Item>
                  <List.Item onClick={hancleClickDel}><div className='dbd-sub-nav'><SvgIcon type='trash-can-icon' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text">{formatMessage({ id: 'menu_delete' })}</div></div></List.Item>
                  {/* 分割线 */}
                  <List.Item className='tea-list__separate dbd-sub-line' />
                  <Popover
                    placement="right-start"
                    placementOffset={[0, 8]}
                    overlay={<div className='tea-dropdown-box dbd-menu-option'>
                      <List type="option">
                        {(moveToMenu || [])?.map((folder: any) => {
                          return (<>
                            <List.Item
                              disabled={folder?.id === item?.parent_id || folder?.name_en === FOLDER_NAME_MYDASHBOARD || folder?.name_en === FOLDER_NAME_FAVORITES}
                              key={folder?.id}
                              onClick={() => { handleMoveToMenu(folder?.id, folder?.id) }}>
                              {isZh && folder?.name_cn || folder?.name_en}
                            </List.Item>
                            {/* 报表可移动到三级子目录 */}
                            {
                              folder?.dashoboard_list?.map((subfolder: any) => {
                                if (subfolder?.menu_type === '2') return null;
                                return <List.Item
                                  style={{ paddingLeft: '30px' }}
                                  disabled={subfolder?.id === item?.parent_id || folder?.name_en === FOLDER_NAME_MYDASHBOARD || folder?.name_en === FOLDER_NAME_FAVORITES}
                                  key={subfolder?.id}
                                  onClick={() => { handleMoveToMenu(folder?.id, subfolder?.id) }}>
                                  {isZh && subfolder?.name_cn || subfolder?.name_en}
                                </List.Item>;
                              })
                            }
                          </>);
                        })}
                      </List>
                    </div>
                    }
                  >
                    <List.SubMenu label={<div className='dbd-sub-nav'><SvgIcon type='file-move-icon' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text">{formatMessage({ id: 'menu_move_to' })}</div></div>}></List.SubMenu>
                  </Popover>
                  <Popover
                    placement="right-start"
                    placementOffset={[0, 8]}
                    overlay={<div className='tea-dropdown-box'>
                      <List type="option">
                        <List.Item onClick={handleClickShiiftUP} disabled={isFirst}>
                          <div className={`dbd-sub-nav ${isFirst?'disabled':''}`}><SvgIcon type='rising-arrow-icon' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text"> {formatMessage({ id: 'menu_shift_up' })}</div></div>
                        </List.Item>
                        <List.Item onClick={handleClickShiiftDown} disabled={isLast}>
                          <div className={`dbd-sub-nav ${isLast?'disabled':''}`}><SvgIcon type='down-arrow-icon' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text"> {formatMessage({ id: 'menu_shift_down' })}</div></div>
                        </List.Item>
                      </List>
                    </div>
                    }
                  >
                    <List.SubMenu label={<div className='dbd-sub-nav'><SvgIcon type='order-icon' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text">{formatMessage({ id: 'menu_order' })}</div></div>}></List.SubMenu>
                  </Popover>
                </>
              }
            </List>
          </div>
        }
      >
      </Popover>
    </>
  );
};
